import Navigation from "@/components/Navigation"
import Footer from "@/components/Footer"

export default function CGV() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-display font-bold mb-8 mt-6 text-center">Conditions générales de vente</h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">1. Généralité et définition</h2>
              <p className="text-muted-foreground">
                La société 1YEAR1BOOK (ci-après « Wememberz »), SARL immatriculée au RCS de Paris sous le numéro 523 806 669 et dont le siège social est situé 10 rue Thibaud, 75014 Paris, exploite le site internet www.wememberz.com (ci-après le « Site ») et l’application mobile « Wememberz » (ci-après l’ « Application »).

<br/><br/>
Wememberz met le Site et l’Application mobile à disposition de ses utilisateurs (ci-après « Utilisateurs ») dans le but de leur fournir un ensemble de services liés à la photographie numérique (ci-après les « Services »).

<br/><br/>
Les conditions générales de ventes énumérées ci-dessous (ci-après les « CGV ») s'appliquent à l'ensemble de ces Services. Toutes questions relatives aux CGV peuvent être adressées à contact@wememberz.com.

<br/><br/>
Toute commande effectuée sur le Site et sur l’Application est subordonnée à l'acceptation des CGV par l’Utilisateur qui coche la case « J’accepte les Conditions Générales de Vente préalablement à la validation d'une commande. En cochant cette case, l’Utilisateur confirme l’acceptation pleine et entière de ces conditions. Cela implique obligatoirement l'acceptation sans réserve par le client des CGV.

<br/><br/>
Les CGV sont susceptibles d'être modifiées à tout moment sans préavis.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2. Services offerts sur le Site et sur l’Application</h2>
              <p className="text-muted-foreground">
                Wememberz propose sur son Site et son Application les Services énumérés ci-dessous, qui sont également décrits sur le Site et sur l’Application aussi précisément que possible.
<br/><br/>

En cas de doutes sur les caractéristiques d'un Service, l’Utilisateur peut contacter Wememberz via le formulaire de contact.
<br/><br/>

Afin d'utiliser les Services, l’Utilisateur doit disposer d'une connexion à internet et disposer de tout matériel nécessaire, notamment d'un ordinateur et d'un modem, d’un Smartphone ou de tout outil de connexion et d’un accès internet (les frais de connexion éventuels sont entièrement à la charge de l'utilisateur ou du visiteur).

<br/><br/>
Les Services ne peuvent être revendus par les Utilisateurs ou exploités à des fins commerciales.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2.1 Service d’impression de photographies</h2>
              <p className="text-muted-foreground">
                Wememberz propose à ses Utilisateurs sur le Site et l’Application un service de tirage de photographies numériques en différents formats et un service d’impression d’albums photos.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2.2 Service de personnalisation de produits</h2>
              <p className="text-muted-foreground">
                Wememberz propose à ses Utilisateurs un service de personnalisation d’articles photos (notamment des albums, magnets, calendriers, faire-part, posters, boites à photo) accessible sur le Site et l’Application. La personnalisation de ces articles se fait grâce à un outil de création disponible sur le Site et sur l’Application qui permet à l’Utilisateur de transférer des photographies à imprimer sur différents supports et de personnaliser ces supports.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2.3 Commercialisation de produits non personnalisables</h2>
              <p className="text-muted-foreground">
                Wememberz commercialise sur son Site et son Application des produits liés à l’univers de la photographie et ne pouvant faire l’objet d’aucune personnalisation (notamment des cadres photos, des autocollants, des scotchs adhésifs décoratifs, etc).
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">3. Disponibilité du Site et de l’Application</h2>
              <p className="text-muted-foreground">
                Wememberz s'efforce d'assurer la disponibilité du Site et de l’Application 24 heures sur 24 et 7 jours sur 7. Cependant, Wememberz ne pourra être tenu pour responsable en cas d'indisponibilité pour des raisons d'actualisation et de maintenance du Site ou de l’Application ou d’indisponibilité des serveurs.

<br/><br/>
De même, Wememberz se réserve le droit à tout moment, et sans préavis, d'interrompre ou de modifier le service temporairement ou de façon permanente. Wememberz ne pourra être tenu responsable de toute modification, suspension ou interruption du ou des Service(s).
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">4. Conditions d’accès et utilisation des Services</h2>
                          <h2 className="text-2xl font-semibold mb-4 text-foreground">4.1 Création de compte</h2>
              <p className="text-muted-foreground">
                Afin d’utiliser les Services sur le Site et sur l’Application, l'Utilisateur s’inscrit à partir de son adresse e-mail ou se connecte avec son compte Facebook ou son compte Google Mail.

 <br/> <br/>
<b>Facebook Connect</b>
 <br/> <br/>
Wememberz propose à ses Utilisateurs de se "Facebook Connecter", autrement dit de se connecter via Facebook. Afin de se connecter à Wememberz avec votre compte Facebook, l’Utilisateur doit autoriser Wememberz à accéder à certaines informations Facebook. Cette autorisation est recueillie au moyen du clic "Autoriser" sur la demande de permission affichée par Facebook, qui liste les informations auxquelles Wememberz pourra accéder, à savoir :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Accéder aux informations de base de son compte Facebook (nom, photographie, sexe, liste d'amis, réseaux, identifiants et autres informations publiques) ;</li>
<li>Accéder à toutes les photos du profil Facebook ;</li>
<li>Accéder aux informations du profil Facebook (anniversaire, etc.) ;</li>
<li>Envoyer directement des messages à son adresse e-mail telle que renseignée sur Facebook.</li>
</ul><br/>
  Les informations provenant du compte Facebook de l’Utilisateur auxquelles Wememberz a accès peuvent être modifiées en fonction des modifications apportées par l’API de Facebook.

 <br/> <br/>
<b>Instagram Connect et autres services</b>
 <br/> <br/>
Wememberz propose à ses Utilisateurs de se connecter avec Instagram. Afin de se connecter à Wememberz avec un compte Instagram, l’Utilisateur doit autoriser Wememberz à accéder à ses photos et au contenu associé aux photos : commentaires, likes, tags et description. Cette autorisation est recueillie au moyen du clic "autoriser" sur la demande de permission affichée par Instagram.
 <br/> <br/>

Les informations provenant du compte Instagram de l’Utilisateur auxquelles Wememberz a accès peuvent être modifiées en fonction des modifications apportées par l’API d’Instagram.
 <br/> <br/>

De même, Wememberz propose à ses Utilisateurs de se connecter aux services suivants: Flick'r, Dropbox et Google Photos sur le même mode de fonctionnement.

 <br/> <br/>
<b>Google Mail</b>
 <br/> <br/>
Wememberz propose à ses Utilisateurs de se connecter via leur compte Gmail (Google Mail). Afin de se connecter à Wememberz avec votre compte Gmail, l’Utilisateur doit autoriser Wememberz à accéder à certaines informations Google, notamment l’email. Cette autorisation est recueillie au moyen du clic « autoriser » sur la demande de permission affichée par Google.
                <br/> <br/>

                <h2 className="text-2xl font-semibold mb-4 text-foreground">4.2 Informations fournies par l’Utilisateur</h2>
                L’Utilisateur certifie l’exactitude des informations nécessaires à la facturation et à la livraison de la commande transmise à Wememberz. L’Utilisateur est seul responsable de toute erreur ou omission.

<br/><br/>
L’Utilisateur s’interdit d’utiliser de fausses informations ou d’utiliser les informations de tiers sans autorisation.
<br/><br/>

En cas d'utilisation frauduleuse de votre compte, l’Utilisateur devra alerter Wememberz dans les plus brefs délais à contact@wememberz.com.
                <h2 className="text-2xl font-semibold mb-4 text-foreground">4.3 Droits de propriété intellectuelle de tiers et droit à l’image de tiers</h2>
                Tous les Utilisateurs reconnaissent disposer de l'intégralité des droits sur les photographies dont il est demandé le développement. Wememberz est un service d'impression et ne pourra être tenu pour responsable pour les contenus imprimés qui sont la responsabilité de l'Utilisateur. Les Utilisateurs s'engagent à ne pas violer le droit à l’image de tiers et/ou les droits d'auteur de photographies ne leur appartenant pas qu'ils auraient chargées sur le Site par le biais d'Instagram, de Facebook ou de leur propre ordinateur.

<br/><br/>
Plus largement, l’Utilisateur garantit que les contenus remis à Wememberz ne violent aucun droit de propriété intellectuelle détenu par un tiers.
<br/>
L’Utilisateur est seul responsable des contenus, images ou autres qu’il transmet à Wememberz dans le cadre de l’utilisation des Services.
En aucun cas, Wememberz ne pourra être tenu responsable si le contenu des travaux photographiques transmis par l’Utilisation pour impression viole des droits d'auteur ou de marques détenus par des tiers ou porte atteinte à un tiers de quelque manière que ce soit.

<br/><br/>
L’Utilisateur s’engage à ne pas utiliser les Services mis à disposition par Wememberz à des fins racistes, pédophiles, pornographiques ou plus généralement portant atteinte aux droits de tiers.

<br/><br/>
En tout état de cause, l’Utilisateur s’engage à indemniser Wememberz de toutes les conséquences financières liées à une action judiciaire ou une réclamation émanant de tiers liée à l’utilisation des Services par l’Utilisateur.
<br/><br/>

Wememberz se réserve le droit d'exclure les Utilisateurs qui ne respectent pas les conditions générales exposées ici, en les déconnectant ou en supprimant leur compte et les données inhérentes au compte.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">5. Codes promotionnels, cartes cadeaux et parrainage</h2>
              <p className="text-muted-foreground">
                Wememberz peut communiquer à ses Utilisateurs des codes promotionnels, utilisable 1 ou plusieurs fois selon les cas et dans un délai déterminé.

<br/><br/>
L’Utilisateur peut acheter une ou plusieurs cartes cadeaux sur le Site et sur l’Application. Ces cartes cadeaux ne peuvent être utilisées que pour la commande de Services.

<br/><br/>
Les codes promotionnels et codes délivrés dans les cartes cadeaux sont strictement réservés à un usage unique et personnel. Il n’est en aucun cas autorisé de partager ou publier un code de réduction quel qu'il soit (carte cadeau ou code de réduction).
<br/><br/>

Wememberz se réserve le droit à tout moment, et sans préavis, d'interrompre ou de modifier un code de réduction si celui-ci faisait l'objet d'un partage public. Le ou les codes partagés frauduleusement pourront être modifiés ou désactivés ainsi que toutes les commandes associées à ce ou ces codes et ce sans préavis.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">6. Tarifs</h2>
              <p className="text-muted-foreground">
                L'inscription sur Wememberz est gratuite. L'utilisation des outils de créations en ligne et le dépôt de photos numériques sur un compte Utilisateur est gratuite.
<br/><br/>

Les prix peuvent évoluer à tout moment en fonction de la politique tarifaire. Aucune modification de prix ne s'appliquera aux commandes réalisées ou en cours.

<br/><br/>
Les prix sont indiqués en euros, sauf indication contraire explicitement libellée dans une autre devise. Les prix appliqués sont ceux qui sont affichés au moment de la connexion. Les prix incluent la TVA Française. Dans le cas d'une livraison hors Union Européenne, les frais ne comprennent pas les droits de douane et taxes éventuelles à régler par le client. Le montant de ces taxes dépend du pays de destination, le client devra prendre contact auprès des autorités locales afin de respecter les frais d'importation de marchandise inhérents à son lieu de réception de commande.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">7. Paiement</h2>
              <p className="text-muted-foreground">
                Toute commande effectuée sur le Site doit être réglée au moment de la commande. L’exécution de la commande n’intervient qu’après le paiement intégral par l’Utilisateur du montant de sa commande.

<br/><br/>
Les paiements s'effectuent en ligne au moyen d'un système de paiement en ligne sécurisé. Les commandes peuvent être payées par carte bancaire, via Paypal ou par virement bancaire pour des commandes de grandes quantités (supérieures à 1 000 euros). Wememberz fonctionne avec la solution de paiement bancaire Stripe qui utilise les systèmes de sécurité les plus récents et les plus fiables intégrant notamment la certification PCI DSS. Stripe et Paypal cryptent ces données selon le protocole SSL afin de garantir la sécurité de ces données.

<br/><br/>
L’exécution de la commande sera réalisée après accord du centre de paiement bancaire. En cas d'accord de ce dernier, le compte sera immédiatement débité et la commande validée. En cas de refus la commande sera annulée.

<br/><br/>
Wememberz se réserve le droit d'annuler toute commande pour motif d'incident de paiement. En cas de remboursement, l’Utilisateur sera remboursé par crédit sur le compte bancaire ayant servi au paiement.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">8. Droit de rétractation</h2>
              <p className="text-muted-foreground">
                La préparation des commandes passées par les Utilisateurs s’analyse en une fourniture de biens confectionnés selon les spécifications de ses Utilisateurs et nettement personnalisés, ne pouvant être réexpédiés.
<br/><br/>

Conformément aux dispositions de l'article L.121-20-2, 3° du code de la consommation, ces produits ne donnent pas lieu à un droit de rétractation.

<br/><br/>
Par exception aux dispositions qui précèdent, l’Utilisateur ayant passé commande de produits non personnalisables dispose d’un délai de quatorze jours pour exercer son droit de rétractation, et ce conformément aux dispositions de l’article L221-18 du Code de la consommation.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">9. Livraison</h2>
              <p className="text-muted-foreground">
                Les informations fournies lors de la commande engagent l’Utilisateur. En cas d'informations erronées entraînant l'impossibilité de livrer la commande, Wememberz ne pourra être tenu responsable. L'enregistrement automatique des données renseignées par l’Utilisateur vaut preuve de la nature de la commande, de sa date et de son prix.

<br/><br/>
Les produits disponibles sur le site Wememberz peuvent être livrés en France métropolitaine ou dans les pays de l'Union Européenne moyennant un surcoût précisé au moment de la commande. Les frais de livraison sont fonction du lieu de destination, du type et de la quantité de produits choisis par le client.
<br/><br/>

Le délai de livraison commence à courir une fois la commande entièrement réglée. Ce délai sera précisé sur la page de vérification de la commande client. Toute anomalie ou avarie concernant la commande (produit manquant, produit endommagé) devra être impérativement indiqué dès la livraison et dans les plus brefs délais (3 jours), à Wememberz, et ce conformément aux conditions et modalités exposées ci-après.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">10. Retour de marchandises et remboursement</h2>
              <p className="text-muted-foreground">
                Wememberz s'efforce de répondre aux attentes de ses Utilisateurs et de leur proposer des services de qualité.

<br/><br/>
Si, toutefois, le produit livré n’était pas conforme à la commande passé, au sens de l’article L211-5 du Code de la consommation, l’Utilisateur est en droit d’adresser une réclamation dans un délai de 15 jours à compter de la livraison auprès du service client Wememberz (contact@wememberz.com). Passé ce délai, l’Utilisateur sera considéré comme ayant accepté définitivement sa commande.

<br/><br/>
Toute réclamation pour défaut de conformité doit indiquer les mentions suivantes :
<ul className="list-disc pl-6 text-muted-foreground">
<li>Numéro de commande</li>
<li>Nom, prénom et adresse</li>
<li>Motif de la réclamation pour non-conformité</li>
<li>Photos prouvant la non-conformité du produit</li>
</ul>
                <br/>
Si le défaut de conformité est avéré, l’Utilisateur pourra obtenir le remboursement du produit, sous la forme d’un code promo à utiliser sur le site. Wememberz pourra décider, dans certains cas exceptionnels uniquement, d’effectuer un remboursement via le moyen de paiement utilisé lors de la commande (virement bancaire, Paypal…).
<br/><br/>

Wememberz garantie également ses Utilisateurs contre tout vice caché affectant le produit, et ce conformément à l’article 1641 et suivants du Code civil. La société n'est pas tenue responsable des vices apparents que le client aurait pu par lui-même constater et se convaincre.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">11. Stockage et sécurité des données</h2>
              <p className="text-muted-foreground">
                <b>11.1</b> Wememberz héberge les photos et créations de ses Utilisateurs gratuitement pendant une durée par défaut de 1 an et maximum 5 ans, ce délai passé, les photos ou travaux photographiques seront effacées. Wememberz n'est pas tenu de conserver les créations et photographies transférées par l'Utilisateur et la quantité de photos ou créations photographiques pourra à tout moment être limitée à une certaine capacité par l’Utilisateur.
Aucune garantie de stockage des contenus transmis dans le cadre de l’utilisation des Services n’est assurée à l’Utilisateur. Wememberz ne saurait être tenue pour responsable de la suppression ou de l’effacement de ces contenus.
<br/><br/>
<b>11.2</b> Wememberz s'engage à prendre toutes les précautions utiles au regard des risques présentés par le traitement, pour préserver la sécurité des données et notamment, empêcher qu'elles soient déformées, endommagées, ou que des tiers non autorisés y aient accès. Wememberz s'engage en particulier à respecter l'ensemble des prescriptions techniques auxquelles doivent se conformer les traitements.
Wememberz ne pourra être tenu pour responsable en cas de perte de données de l’Utilisateur ou de leur destruction accidentelle.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">12. Garantie et responsabilité</h2>
              <p className="text-muted-foreground">
                En sus des cas d’exclusion de responsabilité prévus aux articles 3, 4.2, 4.3, 9, 10 et 11 des présentes CGV, la responsabilité de Wememberz ne saura être également engagée :

<br/><br/>
En cas d’erreur technique ou matérielle et de perte de données engendrées par l’Utilisation dans le cadre de l’utilisation du Site ou de l’Application.
<br/><br/>
En cas de dysfonctionnement des services informatiques, notamment le fonctionnement des outils et logiciels proposés sur le Site et sur l’Application. Leur bon fonctionnement dépend de facteurs externes qui ne dépendent pas uniquement de Wememberz.
<br/>
                Du fait de la qualité des contenus transmis par l’Utilisateur pour impression. Wememberz ne garantit pas les résultats obtenus à l'issue de créations photographiques, celles-ci dépendant tant de la qualité de la photographie transmise par l’Utilisateur que de l'usage des outils disponibles sur le Site et l’Application pour effectuer les personnalisations. Ainsi, Wememberz ne saurait être engagée au titre du contenu ou de la qualité des éléments textuels ou photographiques ajoutés par l’Utilisateur aux produits personnalisables.

<br/><br/>
Les informations et conseils qui peuvent être donnés par téléphone ou par mail le sont à titre d'aide d'utilisation du Service mais ne constituent pas de garanties non expressément prévues par les CGV.

<br/><br/>
En cas d'inexécution ou de mauvaise exécution des prestations contractuelles imputables au client notamment lors de la prise de commande.

<br/><br/>
En cas de retard ou d’inexécution, lorsque la cause du retard ou de l'inexécution est liée à un cas de force majeure telle qu'elle est définie par la jurisprudence des cours et tribunaux français.

<br/><br/>
En cas de différence non substantielle entre les visuels des produits présents sur le site Wememberz et le produit commandé.
                
              </p>
            </section>


                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">13. Droits de propriété intellectuelle</h2>
              <p className="text-muted-foreground">
                Tous les droits d’auteur, marques, dessins et modèles sur les éléments du Site et de l’Application ainsi que l’architecture et la présentation du Site et de l’Application sont, avec les codes du logiciel, la propriété exclusive de Wememberz ou de ses concédants.
<br/><br/>

En conséquence, il n’est pas autorisé de copier, modifier, altérer, publier, diffuser, distribuer, vendre ou transférer tout ou partie des éléments du Site ou de l’Application.

<br/><br/>
Toutefois, le contenu du Site peut être téléchargé, imprimé ou copié à des fins personnelles et non commerciales.
              </p>
            </section>

                                                  <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">14. Données personnelles</h2>
              <p className="text-muted-foreground">
                Toutes les informations à caractère personnel communiquées par l’Utilisateur à Wememberz via le Site ou l’Application et celles qui auront ensuite été recueillies dans le cadre de la commande de Services sont soumises aux dispositions figurant dans la rubrique « Politique de Confidentialité » disponible sur le Site.
              </p>
            </section>
                                                                            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">15. Droit applicable</h2>
              <p className="text-muted-foreground">
                Les présentes CGV sont soumises au droit français.

<br/><br/>
Tout litige pouvant résulter de l’application des présentes CGV sera de la compétence des juridictions françaises, et ce quelque soit le lieu de livraison.
              </p>
            </section>
            

          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}